const alwaysNumber = (value) => {
  return Number.isNaN(+value) ? 0 : +value;
};
const formatNumber = (num) => alwaysNumber(num).toLocaleString("en-US", { maximumFractionDigits: 10 });
const getDecimalPrecision = (num) => {
  if (Math.abs(num) < 1) {
    const parts = num.toExponential().split("e-");
    const mantissaDecimalPart = parts[0].split(".")[1];
    return (mantissaDecimalPart ? mantissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }
  const decimalPart = num.toString().split(".")[1];
  return decimalPart ? decimalPart.length : 0;
};
export const valueInRange = (value, range) => Math.min(range[1], Math.max(range[0], value));
export const displayFormatter = (format) => (value) => {
  if (format === "years")
    return `${value}`;
  const valueWithCommas = formatNumber(Number(value));
  return format === "dollars" ? `$${valueWithCommas}` : valueWithCommas;
};
export const displayToNumber = (value) => Number(value.replace(/,|\$/g, ""));
export const roundValueToStep = (value, step, min) => {
  const nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
};
export const getValueFromPixels = (min, max, handleX, sliderWidth, step) => {
  const percent = handleX / sliderWidth;
  const value = percentToValue(percent, min, max);
  return valueInRange(roundValueToStep(value, step, min), [min, max]);
};
const percentToValue = (percent, min, max) => {
  return (max - min) * percent + min;
};
export const valueToPercentage = (min, max, value, secondaryValue = 0, forSecondaryValue = false) => {
  const valueMin = (forSecondaryValue ? secondaryValue : value) - min;
  const valueMax = max - min;
  return valueMin / valueMax * 100;
};
export const valueIsCloserToSecond = (compareValue = 0, values) => {
  const [min = 0, max = 0] = values;
  const primaryDiff = Math.abs(compareValue - min);
  const secondaryDiff = Math.abs(compareValue - max);
  return secondaryDiff < primaryDiff;
};
